module.exports = __webpack_public_path__ + "static/media/resume-solid.18ea591e.svg";